import { html, LitElement, nothing } from 'lit';
import { styleMap } from 'lit/directives/style-map.js';

import { type ColorToken, toCSSValue } from '@loadsmart/miranda-tokens';

import { cardStyles } from './card.styles';

export interface CardProps {
	flagged?: boolean;
	'flag-color'?: ColorToken;
}

const defaultFlagColor: NonNullable<CardProps['flag-color']> =
	'color-background-inverted';

export class Card extends LitElement {
	static override styles = [cardStyles()];

	static override get properties() {
		return {
			flagged: { type: Boolean },
			flagColor: { type: String, attribute: 'flag-color' },
		};
	}

	/**
	 * Should the card be flagged.
	 */
	declare flagged: CardProps['flagged'];

	/**
	 * Card flag color.
	 */
	declare flagColor: NonNullable<CardProps['flag-color']>;

	constructor() {
		super();

		this.flagged = false;
		this.flagColor = defaultFlagColor;
	}

	override render() {
		return html`
			<div
				class="m-card"
				style="${styleMap({
					'--m-card-flag-color': toCSSValue(this.flagColor),
				})}"
			>
				${this.flagged ? html`<span class="m-card-flag"></span>` : nothing}
				<div class="m-card-content">
					<slot name="title"></slot>
					<slot name="subtitle"></slot>
					<slot name="divider"></slot>
					<slot name="body"></slot>
				</div>
			</div>
		`;
	}
}

window.customElements.define('m-card', Card);

declare global {
	interface HTMLElementTagNameMap {
		'm-card': Card;
	}
}
